import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div id={styles.footerContainer}>
      <div id={styles.footerContent}>
        <div className={styles.footerItem}>
          <h5 className={styles.footerItemHeading}>FamilyPlanner</h5>
          <div id={styles.footerItemItems}>
            <Link to="/dashboard">
              <p className={styles.footerItemItem}>Launch app</p>
            </Link>
            <Link to="/settings">
              <p className={styles.footerItemItem}>My account</p>
            </Link>
            <Link to="/about">
              <p className={styles.footerItemItem}>About</p>
            </Link>
          </div>
        </div>
        <div className={(styles.footerItem, "not-964px")}>
          <h5 className={styles.footerItemHeading}>Platforms</h5>
          <div id={styles.footerItemItems}>
            <Link to="/download">
              <p className={styles.footerItemItem}>Web</p>
            </Link>
            <Link to="/download">
              <p className={styles.footerItemItem}>Windows / MacOS</p>
            </Link>
            <Link to="/download">
              <p className={styles.footerItemItem}>IOS</p>
            </Link>
            <Link to="/download">
              <p className={styles.footerItemItem}>Android</p>
            </Link>
          </div>
        </div>
        <div className={(styles.footerItem, "not-600px")}>
          <h5 className={styles.footerItemHeading}>Help</h5>
          <div id={styles.footerItemItems}>
            <p className={styles.footerItemItem}>Tutorials</p>
            <p className={styles.footerItemItem}>Report a bug</p>
            <p className={styles.footerItemItem}>Contact</p>
          </div>
        </div>
        <div className={(styles.footerItem, "not-600px")}>
          <h5 className={styles.footerItemHeading}>Products</h5>
          <div className="" id={styles.footerItemItems}>
            <p className={styles.footerItemItem}>Robyte</p>
            <p className={styles.footerItemItem}>Familyplanner</p>
            {/* <p className={styles.footerItemItem}>Grady</p> */}
          </div>
        </div>
      </div>
      <div id={styles.footerCopyright}>
        <p>Robin Aerts - © Copyright 2023 - Robyte.me </p>
      </div>
    </div>
  );
}
